function readMatchRecordId(matchData) {
  if (!matchData || typeof matchData !== "object") return "";
  const raw = matchData.matchId || matchData._id || matchData.id;
  if (raw == null || raw === false) return "";
  if (typeof raw === "object") {
    return String(raw.$oid || raw.toString?.() || "").trim();
  }
  return String(raw).trim();
}

/**
 * MatchPage used catalog.matchFound as a boolean, but that field is also
 * cleared to null when the accept dialog closes. Show loading until this
 * route's match is actually loaded; only then show not-found.
 */
export function getMatchPageViewState({
  routeMatchId,
  matchData,
  matchPageMissingId,
} = {}) {
  const routeId = String(routeMatchId || "").trim();
  const loadedId = readMatchRecordId(matchData);
  if (routeId && loadedId && loadedId === routeId) return "ready";
  if (routeId && String(matchPageMissingId || "").trim() === routeId) {
    return "missing";
  }
  return "loading";
}

export { readMatchRecordId };
